<div id="huawei-egypt" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">

  <div class="huawei_banner">

    <img src="assets/img/huawei/huawei-banner.jpg" class="img-responsive hidden-xs" alt="">

    <img src="assets/img/huawei/huawei-banner-mobile.jpg" class="img-responsive hidden-sm hidden-lg hidden-md" alt="">

  </div>

  <div class="container" style="margin-top:50px;">

    <div class="col-md-4">

      <div class="prize_info">
        <h1 class="prize_info">         <i style="color:#fff; font-size: 50px" class="icon-ticket"></i>
          <br> المركز الاول و الثاني</h1>
        <p>رحلة إلى دبي </p>
       <h1 class="prize_info"> <i style="color:#fff; font-size: 50px" class="icon-mobile"></i>
         <br> المركز الثالث إلى الخامس</h1>
        <p>Huawei Y9 2019 هاتف</p>
      </div>
      <div class="phone-mockup">
        <div class="huawei_button">
          <a href="https://www.gbarena.com/tournaments/blfrS443yuYF/summary" target="_blank" class="go_button green square wide" >
            {{language?.Join_now}}
          </a>
        </div>
      </div>

    </div>

    <div class="col-md-8 ">
      <mat-tab-group class="huawei_tabs"  style="direction: ltr;">

          <mat-tab label="{{language?.Timeline}}">

              <div class="honor-rules">
                  <div class="col-lg-12" style="background: #173b50; border: solid 1px #2b6486;">
              <pre>
                <h1> <i class="icon-calendar"></i>المرحلة الاولى</h1>
                <p>سيتم لعب مباراة واحدة لكل لاعب في هذة المرحلة و سيصعد اول (٢٠) لاعب من كل مباراة للمرحلة الثانية</p>

                 <div class="pointing_table">
                   <ul>
                      <li class="title">
                        <p>{{language?.Match_Number}}</p>
                       <p>{{language?.Match_date}}</p>
                     </li>
                     <li>
                       <p>١</p>
                       <p>٧ اكتوبر، ٦:٠٠م</p>
                     </li>
                      <li>
                       <p>٢</p>
                       <p>٧ اكتوبر، ٩:٠٠م</p>
                     </li>
                      <li>
                       <p>٣</p>
                       <p>٨ اكتوبر، ٦:٠٠م</p>
                     </li>
                      <li>
                       <p>٤</p>
                       <p>٨ اكتوبر، ٩:٠٠م</p>
                     </li>
                      <li>
                       <p>٥</p>
                       <p>٩ اكتوبر، ٦:٠٠م</p>
                     </li>
                      <li>
                       <p>٦</p>
                       <p>٩ اكتوبر، ٩:٠٠م</p>
                     </li>
                      <li>
                       <p>٧</p>
                       <p>١٠ اكتوبر، ٦:٠٠م</p>
                     </li>
                      <li>
                       <p>٨</p>
                       <p>١٠ اكتوبر، ٩:٠٠م</p>
                     </li>
                   </ul>
                 </div>

                <h1> <i class="icon-calendar"></i>المرحلة الثانية</h1>
                <p>سيتم لعب ثلاث مباريات لكل لاعب في هذة المرحلة و سيصعد اول (١٠) لاعبين من كل مباراة للمرحلة النهائية</p>

                 <div class="pointing_table">
                   <ul>
                      <li class="title">
                        <p>{{language?.Match_Number}}</p>
                       <p>{{language?.Match_date}}</p>
                     </li>
                     <li>
                       <p>٩</p>
                       <p>١٤ اكتوبر، ٦:٠٠م</p>
                     </li>

                      <li>
                       <p>١٠</p>
                       <p>١٥ اكتوبر، ٦:٠٠م</p>
                      </li>
                   </ul>
                 </div>

                 <h1> <i class="icon-calendar"></i>المرحلة النهائية</h1>
                <p>سيتم لعب ثلاث مباريات لكل لاعب في هذة المرحلة و سيتم تحديد الفئزين - سيتم التواصل مع المشتركين في هذة المرحلة واخطارهم بمكان المباراة النهائية</p>

                <div class="pointing_table">
                   <ul>
                      <li class="title">
                        <p>{{language?.Match_Number}}</p>
                       <p>{{language?.Match_date}}</p>
                     </li>
                     <li>
                       <p>١١</p>
                       <p>٢٠ اكتوبر، ٨:٠٠م</p>
                     </li>
                   </ul>
                 </div>
              </pre>
                  </div>
              </div>
          </mat-tab>

          <mat-tab label="{{language?.Tournament_rules}}">
          <div class="honor-rules">
            <div class="col-md-12" style="background: #173b50; border: solid 1px #2b6486;">

              <pre>
                <h1 class="rule_title"><i class="icon-doc-text-inv"></i> {{language?.Rules_title}}</h1>
                 <p> {{language?.Rules}}</p>
              </pre>
            </div>
          </div>
        </mat-tab>

          <mat-tab label="{{language?.Pointing_System}}">

          <div class="honor-rules">
            <div class="col-lg-12" style="background: #173b50; border: solid 1px #2b6486;">
               <pre>
                 <h1 class="rule_title"><i class="icon-ok"></i>{{language?.Pointing_Rules}}
                 <br>
                 {{language?.Pointing_kills}} 50 Point*</h1>

                 <div class="pointing_table">
                   <ul>
                      <li class="title">
                       <p>{{language?.Rank}}</p>
                       <p>{{language?.Points}}</p>
                     </li>
                     <li>
                       <p>1</p>
                       <p>500 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>2</p>
                       <p>300 {{language?.Point}}</p>
                     </li>
                       <li>
                       <p>3-4</p>
                       <p>290 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>5-6</p>
                       <p>230 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>7-9</p>
                       <p>180 {{language?.Point}}</p>
                     </li>
                      <li>
                       <p>10-12</p>
                       <p>140 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>13-16</p>
                       <p>110 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>17-20</p>
                       <p>90 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>21-25</p>
                       <p>80 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>31-50</p>
                       <p>60 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>51-70</p>
                       <p>50 {{language?.Point}}</p>
                     </li>
                     <li>
                       <p>71-100</p>
                       <p>40 {{language?.Point}}</p>
                     </li>
                   </ul>
                 </div>

             </pre>

            </div>
          </div>

        </mat-tab>

      </mat-tab-group>
    </div>




  </div>

  <div class="bottom_background"></div>
</div>

<!--footer-->
<div class="huawei_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/logo-gray.svg" alt=""></a>

  <p>This tournament is organized by <a href="http://www.arabhardware.net" target="_blank">Arabhardware</a><br> hosted
    and powered by
    <a href="https://gbarena.com" target="_blank">GBarena</a>.
  </p>

</div>
